import ext from './de-ext.js'
export default {
	"name": "Cms",
	"ext": ext,
	"layout": {

	},
}
